import { ArrowUpRight, MoveUpRight, PackageCheck, Users } from "lucide-react";
import React from "react";

const PrescriptionsOverviewHeader: React.FC = () => {
    return (
        <div className="w-full border border-gray-200 rounded-lg p-4 flex flex-row items-center justify-between">
            <div className="flex flex-col items-start justify-between w-[30%]">
                <div className="flex flex-col items-start justify-start w-full h-[120px]">
                    <div className="flex flex-row items-center justify-between w-full mb-2">
                        <span className="font-normal text-gray-500 text-base">Pending RX</span>
                        <Users className="h-6 w-6 text-gray-500" />
                    </div>
                    <span className="text-xl">47</span>
                </div>
                <span className="font-normal text-gray-500 text-sm">Awaiting Approval</span>
            </div>
            <div className="h-[120px] border-[0.2px] border-gray-300 mx-6" />
            <div className="flex flex-col items-start justify-between w-[30%]">
                <div className="flex flex-col items-start justify-start w-full h-[120px]">
                    <div className="flex flex-row items-center justify-between w-full mb-2">
                        <span className="font-normal text-gray-500 text-base">Pharmacist Productivity</span>
                        <PackageCheck className="h-6 w-6 text-gray-500" />
                    </div>
                        <span className="text-xl">98.2%</span>
                </div>
                <div className="flex flex-row items-center gap-x-1">
                    <MoveUpRight className="h-5 w-5 text-green-500" />
                    <span className="font-normal text-green-700 text-sm mr-4">4.2   </span>
                    <span className="font-normal text-gray-500 text-sm">Performance Score</span>
                </div>
            </div>
            <div className="h-[120px] border-[0.2px] border-gray-300 mx-6" />
            <div className="flex flex-col items-start justify-between w-[30%]">
                <div className="flex flex-col items-start justify-start w-full h-[120px]">
                    <div className="flex flex-row items-center justify-between w-full mb-2">
                        <span className="font-normal text-gray-500 text-base">Approved RX</span>
                        <ArrowUpRight className="h-6 w-6 text-gray-500" />
                    </div>
                    <span className="text-xl">156</span>
                </div>
            </div>
        </div>
    );
}

export default PrescriptionsOverviewHeader;
